module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M5,4H2V3h3V4z M13,10c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S14.7,10,13,10z M24,5v17H0V5h5.9c0.7,0,1.3-0.3,1.7-0.9L9,2h8\nl1.4,2.1c0.4,0.6,1,0.9,1.7,0.9H24z M5,9c0-0.6-0.4-1-1-1S3,8.4,3,9s0.4,1,1,1S5,9.6,5,9z M18,13c0-2.8-2.2-5-5-5s-5,2.2-5,5\ns2.2,5,5,5S18,15.8,18,13z\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/camera.svg
// module id = 783
// module chunks = 1